export default __webpack_public_path__ + "static/media/loading.84a3db4b.svg";